export default __webpack_public_path__ + "static/media/7770BLEU.b0e456d2.pdf";